import type { WithNullsForOptional } from "../SocketClientFunctions"


/** The value with its null optional fields left out, which is what null stands for there. */
export function withoutNullFields<T extends object>(value: WithNullsForOptional<T>): T {
    const copy = { ...value }
    for (const key of Object.keys(copy)) {
        if (Reflect.get(copy, key) === null) {
            Reflect.deleteProperty(copy, key)
        }
    }
    return copy as T
}
